import React from "react"
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
} from 'reactstrap'
import get from 'lodash/get'
import DatePicker from 'react-datepicker'
import SearchIcon from "../../../static/images/search_icon.svg"
import { FONTS, COLORS } from '../../../constants'
import moment from '../../../lib/moment.js'

const ExportReportForm = (props) => {
  const { handleInputExport, toggle } = props
  const { showExport } = props
  const startDateExport = get(props, 'startDateExport')
  const endDateExport = get(props, 'endDateExport')

  return (
    <Modal
      isOpen={ showExport }
      toggle={ () => toggle() }
    >
      <ModalHeader
        toggle={ () => toggle() }
      >
        <HeadLabel>Export</HeadLabel>
      </ModalHeader>
      <ModalBody>
        <Text>Select Date</Text>
        <DatePickerWrapper>
          <ExportDatePicker
            autoComplete='off'
            onChange={ (e) => handleInputExport('startDateExport', e) }
            placeholderText='DD/MM/YYYY'
            selected={ startDateExport }
            dateFormat="DD/MM/YYYY"
            showYearDropdown
            showMonthDropdown
          />
          &nbsp;&nbsp;-&nbsp;&nbsp;
          <ExportDatePicker
            autoComplete='off'
            onChange={ (e) => handleInputExport('endDateExport', e) }
            placeholderText='DD/MM/YYYY'
            selected={ endDateExport }
            dateFormat="DD/MM/YYYY"
            showYearDropdown
            showMonthDropdown
          />
        </DatePickerWrapper>
      </ModalBody>
      <ModalFooter>
        <ExportButton
          color="success"
          disabled={ startDateExport === '' || endDateExport === '' }
          onClick={ () => props.export() }
        >Export</ExportButton>
      </ModalFooter>
    </Modal>
  )
}

export default class SearchbarReport extends React.Component {
  state={
    showExport: false,
    startDateExport: get(this.props, 'startDate'),
    endDateExport: get(this.props, 'endDate'),
  }

  clickExportButton = () => {
    this.setState({
      showExport: !this.state.showExport,
      startDateExport: get(this.props, 'startDate'),
      endDateExport: get(this.props, 'endDate'),
    })
  }

  handleInputExport = (field, data) => {
    switch (field) {
      case 'startDateExport': {
        this.setState({ startDateExport: data })
        break
      }
      case 'endDateExport': {
        this.setState({ endDateExport: data })
        break
      }
      default:
        break
    }
  }

  export = () => {
    const { exportSubcontract } = this.props
    const { startDateExport, endDateExport } = this.state
    exportSubcontract(
      moment(startDateExport).format('YYYY-MM-DD'),
      moment(endDateExport).format('YYYY-MM-DD'),
      localStorage.getItem('access_token')
    )
    this.clickExportButton()
  }

  render() {
    return (
      <Wrapper>
        <WrapperButton>
          <SearchField
            placeholder='Search by name, project ...'
            onChange={ (e) => {
              if (e.target.value === '') this.props.handleSearch(e.target.value)
              this.setState({ tempSearch: e.target.value })
            } }
            onKeyDown={ (e) => {
              if (e.keyCode === 13) this.props.handleSearch(this.state.tempSearch)
            } }
          />
        </WrapperButton>
        <WrapperButton>
          <SearchDatePicker
            autoComplete='off'
            dateFormat='DD/MM/YYYY'
            selected={ get(this.props, 'startDate') }
            onChange={ (e) => this.props.handleDate('start_date', e) }
          />
          <SearchDatePicker
            autoComplete='off'
            dateFormat='DD/MM/YYYY'
            selected={ get(this.props, 'endDate') }
            onChange={ (e) => this.props.handleDate('end_date', e) }
          />
          <CustomButton
            bg={ COLORS.UPLOAD_COLOR }
            border={ COLORS.UPLOAD_COLOR_BORDER }
            onClick={ () => this.clickExportButton() }
          >
            Export
          </CustomButton>
        </WrapperButton>
        <ExportReportForm
          { ...this.state }
          showExport={ this.state.showExport }
          toggle={ this.clickExportButton }
          handleInputExport={ this.handleInputExport }
          export={ this.export }
        />
      </Wrapper>
    )
  }
}

ExportReportForm.propTypes = {
  handleInputExport: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  showExport: PropTypes.bool.isRequired,
  export: PropTypes.bool.isRequired,
}
SearchbarReport.propTypes = {
  exportSubcontract: PropTypes.func.isRequired,
  handleDate: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  background-color: #ffffff;  
  height: 40px;
  position: relative;
  width: 100%;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const WrapperButton = styled.div`
  display: flex;
  margin-left: 1%;
  margin-right: 1%;
`
const SearchField = styled.input`
  height: 30px;
  width: 300px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const HeadLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  position: relative;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const ExportDatePicker = styled(DatePicker)`
  font-family: 'Gotham' !important;
  width: 200px;
  height : 45px ;
  font-size: 12px ;
  padding-left: 5%;
  float: right;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
`
const Text = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const SearchDatePicker = styled(DatePicker)`
  font-family: 'Gotham' !important;
  width: 100px;
  height: 30px;
  font-size: 12px ;
  padding-left: 5%;
  border-radius: 5px;
  margin-right: 10px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
`
const ExportButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const DatePickerWrapper = styled.div`
  display: flex;
  align-items: center;
`




// WEBPACK FOOTER //
// ./src/components/searchbar-report/subcontract/index.js